<script>
  import Clock from '/components/Atoms/Clock.svelte'

  export let cards

  // add order
  cards = cards.map( (c, i) => ({...c, order: i }) )

  // distribute to columns
  const columnCards = [
    { 
      name: "left",
      cards: cards.filter( c => c.column !== "right" )
    },{
      name: "right",
      cards: cards.filter( c => c.column === "right" )
    }
  ]

</script>

<div class="container">
  <div class="dateTimeContainer">
    <Clock />
  </div>
  <div class="columnContainer">
    {#each columnCards as column}
      <div class={column.name}>
        {#each column.cards as card}
          <div class="card" class:featured={card.featured} class:moveup={card.moveup} style="order: {card.order}" data-sortGroup={card.column} >
            <svelte:component this={card.component} {...card.props}>
              {card.content}
            </svelte:component>
          </div>
        {/each}
      </div>
    {/each}
  </div>
</div>

<style lang="scss">


  .container {

    max-width: $maxwidth - 2*$grid-gap-large;
    box-sizing: border-box;

    .card {
      margin-bottom: 20px;
      &.moveup {
        margin-top: -10px;
      }
      &.featured {
        @include height-square(2, 0.56);
        @include media-1col-only {
          @include height-square(1, 5/4);
        }
      }
    }

    @include media-xl {
      margin: 0 auto;
    }

    margin: 0 $grid-gap-large;
    @include media-small {
      margin: 0 $grid-gap-small;
    }
  }
  
  .columnContainer {
    display: flex;
    @include media-1col-only {
      flex-direction: column;
    }

    @include media-2col {
      display: flex;
    }

  }

  @include media-1col-only {
    .left, .right {
      display: contents;
    }
  }

  @include media-2col {
    .left, .right {
      flex: 1;
    }

    .left {
      padding-right: $grid-gap-large / 2;
      @include media-small {
        padding-right: $grid-gap-small / 2;
      }
    }

    .right {
    padding-left: $grid-gap-large / 2;
      @include media-small {
        padding-left: $grid-gap-small / 2;
      }
    }
  }

  .dateTimeContainer {
    position: relative;
    margin-bottom: 15px;
    padding-left: 30px;

    @include media-small {
      padding-left: 20px;
    }
    @include media-larger {
      padding-left: 40px;
    }
  }
</style>